import { Calendar } from "@tamagui/lucide-icons";
import { Timestamp } from "firebase/firestore";
import { FormSheetType } from "../../core/components/FormDataModal";
import type { BusinessReminderModuleSettings } from "./BusinessReminder/BusinessReminderModuleModel";
import { type BusinessModuleMetaCategory, BusinessModuleType } from "./types";

export const allBusinessModulesAvailable: BusinessModuleMetaCategory[] = [
  {
    title: "",
    modules: [
      {
        emoji: "🕥",
        type: BusinessModuleType.Reminder,
        title: "Reminder",
        description:
          "Based on dates, receive reminders, add information and set owners.",
        extraData: [
          {
            label: "Due date",
            placeholder: "Due date",
            type: FormSheetType.Date,
            formKey: "dateDue",
            icon: Calendar,
          },
        ],
        prepareData: (data): BusinessReminderModuleSettings => {
          data.offsetInDays = null; // TODO
          data.dateDue = Timestamp.fromDate(new Date(data.dateDue));
          return data;
        },
      },

      {
        emoji: "👀",
        type: BusinessModuleType.Info,
        title: "Information",
        description: "Add any information and discuss about it if needed",
      },
    ],
  },
];
